import { inject } from '@angular/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { AppPricingService } from '@core/services/app-pricing.service';

/**
 * Loads dynamic pricing parameters from the backend at app startup.
 * Failure is non-blocking: the service keeps its constant fallback.
 */
export async function initAppPricing(): Promise<void> {
  const pricing = inject(AppPricingService);
  try {
    await firstValueFrom(forkJoin([pricing.loadAppAnnualPrice(), pricing.loadAppRegularPrice()]));
  } catch {
    // Non-blocking: keep the constant fallbacks already set in the service.
  }
}
